import { Input } from '@/components/ui/input'
import { useTranslation } from '@/hooks/use-translation'
import type { TextFilterProps } from '../../types/data-table.types'

export function TextFilter({ columnId, columnTitle, value, onChange }: TextFilterProps) {
  const t = useTranslation()

  return (
    <div className="space-y-1">
      <label htmlFor={`filter-text-${columnId}`} className="text-xs font-medium">
        {columnTitle}
      </label>
      <Input
        id={`filter-text-${columnId}`}
        placeholder={`${t('dataTable.searchIn').replace('{column}', columnTitle)}`}
        value={value || ''}
        onChange={(e) => onChange(e.target.value || undefined)}
        className="w-full h-7 text-xs"
      />
    </div>
  )
}
